import React from "react";

function badgeSrc(path) {
  if (typeof window.getPublicUrl === "function") {
    return window.getPublicUrl(path);
  }
  const base = process.env.PUBLIC_URL || "";
  const normalized = path.startsWith("/") ? path.slice(1) : path;
  return base ? `${base}/${normalized}` : `/${normalized}`;
}

/** Promo callouts — Best Value / Most Popular / $125 Savings PNG icons. */
export default function PlanCardPromoBadges({
  showMostPopular = false,
  showBestValue = false, 
  showBestSavings = false,
  placement = "corner",
  className = "",
}) {
  if (!showMostPopular && !showBestValue && !showBestSavings) return null;

  const bestValueSrc = badgeSrc("/assets/images/best value.png");
  const mostPopularSrc = badgeSrc("/assets/images/most_popularUpdated.png");
  const bestSavingsSrc = badgeSrc("/assets/images/100_Savings.png");

  return (
    <div
      className={`signup-plan-card-right-labels signup-plan-card-right-labels--${placement}${
        className ? ` ${className}` : ""
      }`}
    >
      {showMostPopular ? (
        <img
          src={mostPopularSrc}
          alt="Most Popular!"
          className="signup-plan-card-badge-img signup-plan-card-badge-img--most-popular"
        />
      ) : null}
      {showBestValue ? (
        <img
          src={bestValueSrc}
          alt="Best Value!"
          className="signup-plan-card-badge-img signup-plan-card-badge-img--best-value"
        />
      ) : null}
      {showBestSavings ? (
        <img
          src={bestSavingsSrc}
          alt="$125 Savings"
          className="signup-plan-card-badge-img signup-plan-card-badge-img--best-savings"
        />
      ) : null}
    </div>
  );
}
